<template>
  <main class="container">
    <div class="page pension">
      <section class="page__intro">
        <h1 class="page__title">Ta kontroll över din framtida ekonomi</h1>
        <p>Visste du att det inte bara är summan i det orangea kuvertet som utgör din framtida inkomst eller det som kallas pension. Vi ger dig en transparent bild över vad du kan få och vilka ändringar som kan påverka din pension till det bättre.
          <br/><br/>
          Denna översikt visar dina befintliga pensionsbesparingar. I vissa fall väljer du själv hur du vill placera dina pengar, är du inte nöjd med någon av fonderna kan du alltid be om hjälp från våra experter som kan rekommendera alternativ för att optimera din pension.
        </p>
      </section>
      <LoadingSpinner v-if="isLoading"/>
      <Table class="page__main" :items="items" v-else/>
    </div>
  </main>
</template>

<script>
import Table from '../components/pension/Table';
import { LoadingSpinner } from '../components/';
import { mapActions, mapGetters } from 'vuex';

export default {
  name:"Pension",
  components : {
    Table,
    LoadingSpinner
  },
  created() {
    if(!this.insurances.status){
        this.getInsurances()
    }
  },
  methods: {
    ...mapActions(['getInsurances']),
    numberSpacing (nr) {
      return nr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
  },
  computed: {
    ...mapGetters([ 'insurances', 'user' ]),
    isLoading: function () {
      return this.insurances.status === 'loading'
    },
    items: function () {
      const insurances = this.$store.getters.insurances
      const settings = this.$store.getters.user.access

      let array = [
        {
          asset: 'Allmän pension',
          fee: 'N/A',
          development: 'N/A',
          worth: this.numberSpacing(insurances.pensions.overview?.allmanpension),
          rate: 1 // Grey: 0, Green: === 1, Yellow: 2 - 3, Red >= 3
        },
        {
          asset: 'Premiepension',
          fee: 'N/A',
          development: 'N/A',
          worth: this.numberSpacing(insurances.pensions.overview?.premiepension),
          rate: 1
        },
      ]

      for(let i in insurances.ins.details) {
        array.push({
          asset: insurances.ins.details[i].name,
          fee: 'N/A',
          development: 'N/A',
          worth: this.numberSpacing(insurances.ins.details[i].totalAmount),
          rate: 2
        })
      }

      array.push(
        {
          asset: 'Lönekonto',
          fee: 'N/A',
          development: 'N/A',
          worth: settings.income.monthlySalary,
          rate: 4,
          editable: true,
          userAdded: true,
        },
        {
          asset: 'Sparkonton / ISK',
          fee: 'N/A',
          development: 'N/A',
          worth: settings.savingsAccount.value,
          rate: 4,
          editable: true,
          userAdded: true,
        },
        {
          asset: 'Fastigheter',
          fee: 'N/A',
          development: 'N/A',
          worth: settings.realEstate.value,
          rate: 0,
          editable: true,
          userAdded: true,
        },
        {
          asset: 'Bil',
          fee: 'N/A',
          development: 'N/A',
          worth: settings.vehicle.value,
          rate: 0,
          editable: true,
          userAdded: true,
        },
        {
          asset: 'Båt',
          fee: 'N/A',
          development: 'N/A',
          worth: settings.boat.value,
          rate: 0,
          editable: true,
          userAdded: true,
        },
        {
          asset: 'Övrigt',
          fee: 'N/A',
          development: 'N/A',
          worth: settings.other.value,
          rate: 0,
          editable: true,
          userAdded: true,
        },
        {
          asset: 'Lån',
          fee: 'N/A',
          development: 'N/A',
          worth: settings.loan.value,
          rate: 2,
          editable: true,
          userAdded: true,
        },
      )

      return array
    }
  }
}

</script>